import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  authLoading: false,
  configurationSettingsLoading: false,
  configurationSettingsData: null,
  otp_token: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthLoading: (state, action) => {
      state.authLoading = action.payload;
    },
    setConfigurationSettingsLoading: (state, action) => {
      state.configurationSettingsLoading = action.payload;
    },
    setOtpToken: (state, action) => {
      state.otp_token = action.payload;
    },
  },
});

export const { setAuthLoading, setConfigurationSettingsLoading, setOtpToken } = authSlice.actions;
export default authSlice.reducer;
